export * from './Menu';
export * from './MenuItem/MenuItem';
export * from './MenuSeparator/MenuSeparator';
export * from './MenuSection/MenuSection';
export * from './model';
import { provideChameleonDesignSystem } from '../common/ChameleonDesignSystem';
import { chameleonMenu } from './Menu.definition';
import { chameleonMenuItem } from './MenuItem/MenuItem.definition';
import { chameleonMenuSeparator } from './MenuSeparator/MenuSeparator.definition';
provideChameleonDesignSystem().register(chameleonMenu(), chameleonMenuItem(), chameleonMenuSeparator());
